import { createDateTimeFormatter } from "components/helpers";

export const defaultDateTimeFormatter = createDateTimeFormatter();
// For date-only values (YYYY-MM-DD), display as-is without timezone conversion
// Using createDateTimeFormatter would shift the date due to UTC interpretation
export const basicDateFormatter = value => value || "";
